import { statusLabel } from '../lib/format'
import type { RequestStatus } from '../types'

export function StatusPill({ status }: { status: RequestStatus }) {
  return <span className={`status-pill status-pill--${status}`}><i aria-hidden="true" />{statusLabel[status]}</span>
}
